import React from 'react'
import PropTypes from 'prop-types'
import Flex from '../Flex/Flex'
import Text from '../Text/Text'
import Interation from '../Interation/Interation'
import Category from '../Category/Category'
import Avatar from '../Avatar/Avatar'
import styles from './timelineItem.module.scss'

const TimelineItem = (props) => {
  const {
    interactionId,
    category,
    description,
    store,
    indicators,
    userName,
    supervisor
  } = props

  return (
    <div className={styles.timelineItem}>
      <Flex alignItems="center" justifyContent="space-between">
        <Flex alignItems="center">
          {store.logoImageUrl ? (
            <div className={styles.timelineItemIcon}>
              <img src={store.logoImageUrl} alt={store.name} />
            </div>
          ) : (
            <Avatar title={store.name} size="small" />
          )}
          <Text
            size="md"
            color="gray"
            variation="dark"
            bold
            lineHeight="24px"
            margin="0px 0px 0px 16px"
          >
            {store.name}
          </Text>
        </Flex>
        <Interation type={interactionId} />
      </Flex>

      <Flex column margin="24px 0px 0px 0px">
        <Flex>
          <Text
            size="xs"
            lineHeight="20px"
            color="gray"
            variation="dark"
            font="custom"
            extraBold
          >
            {userName ?? 'N/A'}
          </Text>

          <Text
            margin="0px 0px 0px 8px"
            size="xs"
            lineHeight="20px"
            color="gray"
            variation="dark"
            font="custom"
          >
            registrou:
          </Text>
        </Flex>
        {supervisor && (
          <Text size="xxs" color="gray" font="custom">
            {`Responsável - ${supervisor.name}`}
          </Text>
        )}
      </Flex>
      <Text
        size="xs"
        lineHeight="20px"
        color="gray"
        variation="dark"
        font="custom"
        fontWeight="400"
        margin="16px 0px"
      >
        {description}
      </Text>

      {indicators.length > 0 && (
        <Flex alignItems="center" wrap="wrap" style={{ gap: 12 }}>
          {indicators.map((item) => (
            <Text
              key={Math.random()}
              color="gray"
              size="xxs"
              lineHeight="16px"
              bold
              variation="light"
            >
              {item.name}
            </Text>
          ))}
        </Flex>
      )}

      <Flex alignItems="center" margin="30px 0px 0px 0px">
        <Category category={category} />
      </Flex>
    </div>
  )
}

TimelineItem.defaultProps = {
  indicators: [],
  userName: null,
  supervisor: null
}

TimelineItem.propTypes = {
  interactionId: PropTypes.number.isRequired,
  category: PropTypes.number.isRequired,
  description: PropTypes.string.isRequired,
  store: PropTypes.shape({
    name: PropTypes.string,
    logoImageUrl: PropTypes.string
  }).isRequired,
  indicators: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string
    })
  ),
  supervisor: PropTypes.shape({
    name: PropTypes.string
  }),
  userName: PropTypes.string
}

export default TimelineItem
